export function loadTemplateToShadowRoot(element) {
  if (!element.shadowRoot) {
    const template = element.querySelector("template");
    if (!template) {
      return;
    }
    const templateContent = template.content;
    if (!templateContent) {
      return;
    }
    const shadowRoot = element.attachShadow({ mode: "open" });
    shadowRoot.appendChild(templateContent.cloneNode(true));
    template.remove();
    const templatesInShadowRoot = shadowRoot.querySelectorAll("template");
    for (const template of templatesInShadowRoot) {
      const element = template.parentNode;
      if (element) {
        loadTemplateToShadowRoot(element);
      }
    }
  }
}

window.loadTemplateToShadowRoot = loadTemplateToShadowRoot;
